import { jsx as _jsx } from "react/jsx-runtime";
import App from './App';
import { ConfigProvider, ThemeProvider, ToastProvider } from './hoc';
export const VovSystemApp = ({ config, isPreview = false, theme, children, }) => {
    return (_jsx(ThemeProvider, { theme: theme, children: _jsx(ConfigProvider, { config: config, children: _jsx(ToastProvider, { children: _jsx(App, { isPreview: isPreview, children: children }) }) }) }));
};
